import waveMark from '@/assets/brand/wave-mark@96.png'
import { cn } from '@/utils/cn'

interface BrandProps {
  /** Superfície onde a marca aparece — decide o tom do texto "CONTROL". */
  surface?: 'dark' | 'light'
  /** Só o símbolo (a onda), sem o texto. É a versão para telas pequenas. */
  markOnly?: boolean
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

const SIZE = {
  sm: { mark: 'h-7', pacheco: 'text-[1.05rem]', control: 'text-[0.6rem] tracking-[0.34em]' },
  md: { mark: 'h-9', pacheco: 'text-[1.35rem]', control: 'text-[0.72rem] tracking-[0.36em]' },
  lg: { mark: 'h-12', pacheco: 'text-[1.7rem]', control: 'text-[0.9rem] tracking-[0.4em]' },
} as const

/**
 * Marca do PachecoControl. Wordmark na fonte Quadrillion (self-hospedada), com
 * o gradiente azul da identidade em "PACHECO" e "CONTROL" em cinza. Enquanto a
 * fonte não carrega, o `font-display: swap` mostra o mesmo texto em Poppins.
 */
export function Brand({ surface = 'dark', markOnly = false, className, size = 'sm' }: BrandProps) {
  const s = SIZE[size]

  return (
    <span className={cn('inline-flex items-center gap-3', className)}>
      <img src={waveMark} alt="" aria-hidden className={cn('w-auto shrink-0', s.mark)} />

      {!markOnly && (
        <span
          className="flex flex-col font-[family-name:var(--font-brand)] font-bold uppercase leading-[0.95]"
          aria-hidden
        >
          <span className="bg-gradient-to-b from-[#1c87cf] to-[#095ba1] bg-clip-text text-transparent">
            <span className={s.pacheco}>Pacheco</span>
          </span>
          <span
            className={cn(
              'self-stretch text-right font-semibold',
              s.control,
              surface === 'dark'
                ? 'bg-gradient-to-b from-[#e5e7eb] to-[#8b97a4] bg-clip-text text-transparent'
                : 'text-graphite',
            )}
          >
            Control
          </span>
        </span>
      )}

      <span className="sr-only">PachecoControl</span>
    </span>
  )
}
